import ServiceEndpoints from "./ServiceEndpoints";
import {FnPUser} from "../model/FnPUser";
import {LS_USER_INFO} from "../constants/EiopaFnPConstants";

export async function fetchUserInfo(token:string): Promise<FnPUser | undefined> {
    return await fetch(ServiceEndpoints.FetchUserInfo,
        { method: 'get', headers: { "Authorization": "Bearer "+token } })
        .then(async (resp) => {
            if(resp.ok){
                const parsedData:FnPUser = await resp.json();
                return parsedData;
            } else {
                return undefined;
            }
        }).catch((error) => {
            console.error(error);
            return undefined;
        });
}

export async function fetchUserPhoto(token:string)  {
    return await fetch(ServiceEndpoints.FetchUserPhoto,
        { method: 'get', headers: { "Authorization": "Bearer "+token } })
        .then(async (resp) => {
            if(resp.ok){
                return resp.blob()
            } else {
                return undefined;
            }
        }).then((blob) => {
            if(blob) {
                return blob;
            } else {
                return undefined;
            }
        }).catch((error) => {
            console.error(error);
            return undefined;
        });
}

export function setUserInfo(userInfo: FnPUser) {
    const { ncaCode, roles } = userInfo;
    localStorage.setItem(LS_USER_INFO, JSON.stringify({ ncaCode, roles }));
}

export function getUserInfo(token: string | undefined): FnPUser {
    let userInfo: FnPUser = {username: "", ncaCode: "", roles: []};
    const userInfoLS: string = localStorage.getItem(LS_USER_INFO) as string;
    if (userInfoLS !== null) {
        const { ncaCode, roles } = JSON.parse(userInfoLS);
        userInfo.ncaCode = ncaCode;
        userInfo.roles = roles;
    }
    if (token !== undefined) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
        const decodedJWT = JSON.parse(window.atob(base64));
        userInfo.username = decodedJWT.preferred_username
    }
    return userInfo;
}

export function clearUserInfo() {
    localStorage.removeItem(LS_USER_INFO);
}